import React from 'react'
import { Box, Stack } from '@mui/system'
import { getEmsProductImage } from 'src/Libs/installations/utils/product-image'
import { Statement } from 'src/Libs/installations/types'

interface MissingIbnInstallationTypeProps {
  item: Statement
}

/**
 * display missing ibn installation table's 'type' information.
 */
const MissingIbnInstallationType: React.FC<MissingIbnInstallationTypeProps> = ({ item }) => {
  const { type } = item
  return (
    <Stack flexDirection="row" alignItems="center" gap={2}>
      <Box component="img" src={getEmsProductImage(type)} alt="" sx={{ width: '35', height: '35' }} />
      {type}
    </Stack>
  )
}

export default MissingIbnInstallationType
